module.exports = __webpack_public_path__ + "static/media/tempe-campus.1fc0b3b3.jp2";